import React, { useEffect, useState } from "react";
import AdminSidebar from "../../components/partial/AdminNavbar";
import { useDispatch, useSelector } from "react-redux";
import { getCategoryData } from "../../store/category/reducer";
import {
  addTeam,
  deleteTeamData,
  getTeamData,
  updateTeaMData,
} from "../../store/team/reducer";
import { AiOutlineDelete } from "react-icons/ai";
import { FaRegEdit } from "react-icons/fa";
import Button from "../../components/common/Button";
const OurTeam = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [currentMember, setCurrentMember] = useState({
    fullName: "",
    position: "",
    category: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dispatch = useDispatch();
  const teamData = useSelector((state) => state.teamReducer.teamData || []);
  const rawCategory = useSelector(
    (state) => state.categoryReducer.categoryData,
  );
  // normalize: support both raw array (from reducer) and { data: [...] } responses
  const category = Array.isArray(rawCategory)
    ? rawCategory
    : (rawCategory && rawCategory.data) || [];
  console.log("[OurTeam] rawCategory:", rawCategory);
  console.log("[OurTeam] normalized category array:", category);

  useEffect(() => {
    dispatch(getTeamData());
    dispatch(getCategoryData());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const memberData = {
      ...currentMember,
      category: currentMember.category,
    };
    if (isEditing) {
      setTeamMembers((prevMembers) =>
        prevMembers.map((member) =>
          member.id === editId ? { ...member, ...currentMember } : member,
        ),
      );
      dispatch(updateTeaMData(currentMember, currentMember._id));
      dispatch(getTeamData());
      setIsEditing(false);
    } else {
      dispatch(addTeam(memberData));
      dispatch(getTeamData());
    }
    setIsModalOpen(false);
    setCurrentMember({ fullName: "", position: "", category: "" });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this team member?")) {
      dispatch(deleteTeamData(id)).then(() => {
        dispatch(getTeamData);
      });
    }
  };

  const handleEdit = (member) => {
    setCurrentMember({ ...member });
    setIsEditing(true);
    setEditId(member.id);
    setIsModalOpen(true);
  };

  const filteredTeamData =
    selectedCategory === "All"
      ? teamData
      : teamData.filter((member) => member.category.name === selectedCategory);

  const renderTeamMembers = Array.isArray(filteredTeamData) ? (
    filteredTeamData.map((member) => (
      <div
        key={member.id}
        className=";
        flex items-center w-full justify-between mb-4 p-4 border rounded-lg shadow-md bg-white"
      >
        <div className="flex items-center justify-center">
          <div>
            <h3 className="font-semibold text-[#1e81b0]">{member.fullName}</h3>
            <p className="text-gray-700">{member.position}</p>
            <p className="text-sm text-gray-500">{member.category.name}</p>
          </div>
        </div>
        <div>
          <Button
            type="primary"
            onClick={() => handleEdit(member)}
            className="p-2 mr-2 py-2"
          >
            <FaRegEdit title="Edit" />
          </Button>
          <Button
            onClick={() => handleDelete(member._id)}
            type="danger"
            className="p-2 rounded-md py-2"
          >
            <AiOutlineDelete title="Delete" />
          </Button>
        </div>
      </div>
    ))
  ) : (
    <p className="text-red-500">No members available in this category.</p>
  );

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentMember({ fullName: "", position: "", category: "" });
    setIsEditing(false);
  };

  return (
    <div className="flex flex-col md:flex-row md:items-center bg-gray-100 min-h-screen">
      {/* Admin Sidebar */}
      <div className="lg:w-1/5 bg-white shadow-md">
        <AdminSidebar />
      </div>

      {/* Main Content */}
      <div className="flex-1 mr-12 w-full p-6 md:flex-row ">
        <div className="flex flex-col items-center justify-center pb-4 border-b-4 border-black">
          <h2 className="text-3xl text-center font-bold">Our Team</h2>

          {/* Category Filter */}
          <div className="text-end">
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="p-2 border rounded bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#1e81b0]"
            >
              <option value="All">All</option>
              {category.map((v) => (
                <option key={v._id} value={v.name}>
                  {v.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        {/* Add Member Button */}
        <Button
          onClick={() => setIsModalOpen(true)}
          className="items-center justify-center mt-2 py-2 mb-8 text-center px-6"
        >
          Add Member
        </Button>

        {/* Team Members List */}
        <div className="items-center w-full justify-center">
          {renderTeamMembers}
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50"
          onClick={() =>
            // setIsModalOpen(false)
            closeModal()
          }
        >
          <div
            className="bg-white p-6 rounded-lg shadow-lg w-96 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => closeModal()}
              className="absolute top-2 right-2  text-3xl"
              aria-label="Close Modal"
            >
              &times;
            </button>

            <h2 className="text-2xl font-semibold text-[#1e81b0] mb-4">
              {isEditing ? "Edit Member" : "Add Member"}
            </h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Name"
                value={currentMember.fullName}
                required
                onChange={(e) =>
                  setCurrentMember({
                    ...currentMember,
                    fullName: e.target.value,
                  })
                }
                className="border p-3 mb-2 w-full focus:outline-none focus:ring-2 focus:ring-[#1e81b0]"
              />
              <input
                type="text"
                placeholder="Position"
                value={currentMember.position}
                required
                onChange={(e) =>
                  setCurrentMember({
                    ...currentMember,
                    position: e.target.value,
                  })
                }
                className="border p-3 mb-2 w-full  rounded focus:outline-none focus:ring-2 focus:ring-[#1e81b0]"
              />

              <input
                type="email"
                placeholder="Email"
                value={currentMember.email}
                onChange={(e) =>
                  setCurrentMember({
                    ...currentMember,
                    email: e.target.value,
                  })
                }
                className="border p-3 mb-2 w-full  rounded focus:outline-none focus:ring-2 focus:ring-[#1e81b0]"
              />
              <select
                value={currentMember.category}
                onChange={(e) =>
                  setCurrentMember({
                    ...currentMember,
                    category: e.target.value,
                  })
                }
                className="border p-3 mb-2 w-full  rounded focus:outline-none focus:ring-2 focus:ring-[#1e81b0]"
              >
                <option value="">Select a category</option>
                {category.map((v) => (
                  <option key={v._id} value={v._id}>
                    {v.name}
                  </option>
                ))}
              </select>
              <button
                type="submit"
                className=" text-white p-3 mt-4 w-full py-2 bg-[#1e81b0] rounded-md hover:bg-[#1384ba] focus:ring-4 focus:ring-[#1e81b0]"
              >
                {isEditing ? "Update Member" : "Add Member"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default OurTeam;
